// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminResultInsights_page__8PFSf { max-width: 1600px; display: flex; flex-direction: column; gap: 1.5rem; padding: 0; }
.AdminResultInsights_loading__MHZg- { padding: 2rem; color: var(--gray-500); font-size: 0.85rem; }
.AdminResultInsights_noResult__QjSON { padding: 2rem; color: var(--gray-500); display: flex; flex-direction: column; gap: 1rem; }

.AdminResultInsights_topBar__\\+IGx5 { display: flex; align-items: center; justify-content: flex-start; margin-bottom: 1rem; }
.AdminResultInsights_backBtn__PQ9ne { background: none; border: none; color: var(--green); font-size: 0.82rem; font-weight: 500; padding: 0; cursor: pointer; }
.AdminResultInsights_backBtn__PQ9ne:hover { text-decoration: underline; }

.AdminResultInsights_header__PJF8p { margin-bottom: 1.5rem; }
.AdminResultInsights_title__WmBNL { font-size: 1.8rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }
.AdminResultInsights_subtitle__p4nmf { font-size: 0.9rem; color: var(--gray-600); }

.AdminResultInsights_section__IgwIq { margin-bottom: 2rem; }
.AdminResultInsights_sectionTitle__N1ZBY { font-size: 1.2rem; font-weight: 700; color: var(--black); margin-bottom: 1.2rem; border-bottom: 2px solid var(--green); padding-bottom: 0.5rem; }

.AdminResultInsights_insightGrid__nmY5M { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; }

.AdminResultInsights_insightCard__amULn {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1.2rem;
  display: flex;
  gap: 1rem;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.AdminResultInsights_insightCard__amULn:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.AdminResultInsights_insightIcon__NENxY {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  flex-shrink: 0;
}

.AdminResultInsights_insightContent__Wl-bG { flex: 1 1; }
.AdminResultInsights_insightTitle__A48Ya { font-size: 0.8rem; color: var(--gray-600); font-weight: 600; margin-bottom: 0.3rem; text-transform: uppercase; letter-spacing: 0.03em; }
.AdminResultInsights_insightValue__ebybJ { font-size: 1.4rem; font-weight: 700; margin-bottom: 0.4rem; }
.AdminResultInsights_insightDesc__6pyNo { font-size: 0.78rem; color: var(--gray-600); line-height: 1.4; }

.AdminResultInsights_subsectionTitle__tolo3 { font-size: 0.95rem; font-weight: 700; color: var(--gray-900); margin-bottom: 0.8rem; }

.AdminResultInsights_strengthsList__VlG9m { display: flex; flex-direction: column; gap: 0.6rem; }
.AdminResultInsights_strengthItem__9zr\\+H {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  background: rgba(26, 92, 56, 0.04);
  border-radius: var(--radius);
  font-size: 0.85rem;
}

.AdminResultInsights_strengthRank__t70Se {
  font-weight: 700;
  color: var(--green);
  width: 28px;
  text-align: center;
  flex-shrink: 0;
}

.AdminResultInsights_strengthLabel__rIt8x { color: var(--gray-900); flex: 1 1; font-weight: 500; }
.AdminResultInsights_strengthValue__RfY94 { font-weight: 700; }

.AdminResultInsights_analysisCard__vchb2 {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1.2rem;
}

.AdminResultInsights_analysisTitle__LEuqV { font-size: 0.95rem; font-weight: 700; color: var(--gray-900); margin-bottom: 0.6rem; }
.AdminResultInsights_analysisDesc__qN3Yg { font-size: 0.85rem; color: var(--gray-700); line-height: 1.6; }

.AdminResultInsights_levelBarItem__\\+sDmx { margin-bottom: 1rem; }
.AdminResultInsights_levelLabel__HFZs3 { font-size: 0.8rem; font-weight: 600; color: var(--gray-900); margin-bottom: 0.4rem; }

.AdminResultInsights_levelBarContainer__Wujy8 {
  display: flex;
  gap: 0.8rem;
  align-items: center;
}

.AdminResultInsights_levelBarTrack__wfGWY {
  flex: 1 1;
  display: flex;
  gap: 2px;
}

.AdminResultInsights_levelSegment__EVCos {
  height: 12px;
  border-radius: 6px;
  transition: background 0.3s;
}

.AdminResultInsights_levelText__pxNHh { font-size: 0.78rem; font-weight: 600; color: var(--gray-700); min-width: 70px; text-align: right; }

.AdminResultInsights_roadmapList__3B-Xd { display: flex; flex-direction: column; gap: 0.8rem; }
.AdminResultInsights_roadmapItem__xPho\\+ {
  padding: 1rem;
  background: linear-gradient(135deg, var(--green-light) 0%, rgba(26, 92, 56, 0.03) 100%);
  border: 1px solid rgba(26, 92, 56, 0.15);
  border-radius: var(--radius);
  border-left: 4px solid var(--green);
}

.AdminResultInsights_roadmapPhase__OxwQR {
  display: block;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--green);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 0.4rem;
}

.AdminResultInsights_roadmapItem__xPho\\+ p {
  font-size: 0.85rem;
  color: var(--gray-700);
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 1024px) {
  .AdminResultInsights_insightGrid__nmY5M { grid-template-columns: repeat(2, 1fr); }
  
  .AdminResultInsights_roadmapList__3B-Xd { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .AdminResultInsights_page__8PFSf { padding: 1rem; }
  .AdminResultInsights_insightGrid__nmY5M { grid-template-columns: 1fr; }
  .AdminResultInsights_title__WmBNL { font-size: 1.5rem; }
  .AdminResultInsights_sectionTitle__N1ZBY { font-size: 1.1rem; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminResultInsights.module.css"],"names":[],"mappings":"AAAA,mCAAQ,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,UAAU,EAAE;AAC3F,sCAAW,aAAa,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACtE,uCAAY,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAErG,sCAAU,aAAa,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AAChG,sCAAW,gBAAgB,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,UAAU,EAAE,eAAe,EAAE;AACnI,4CAAiB,0BAA0B,EAAE;;AAE7C,qCAAU,qBAAqB,EAAE;AACjC,oCAAS,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC1F,uCAAY,iBAAiB,EAAE,sBAAsB,EAAE;;AAEvD,sCAAW,mBAAmB,EAAE;AAChC,2CAAgB,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,qCAAqC,EAAE,sBAAsB,EAAE;;AAEhK,0CAAe,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;;AAEhF;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,6CAAkB,SAAO,EAAE;AAC3B,2CAAgB,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACvJ,2CAAgB,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC5E,0CAAe,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE7E,8CAAmB,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;;AAExG,4CAAiB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4CAAiB,sBAAsB,EAAE,SAAO,EAAE,gBAAgB,EAAE;AACpE,4CAAiB,gBAAgB,EAAE;;AAEnC;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,4CAAiB,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AACtG,2CAAgB,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE9E,4CAAgB,mBAAmB,EAAE;AACrC,yCAAc,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;;AAElG;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,wCAAa,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAE/G,0CAAe,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AACnE;EACE,aAAa;EACb,uFAAuF;EACvF,wCAAwC;EACxC,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0CAAe,qCAAqC,EAAE;;EAEtD,0CAAe,0BAA0B,EAAE;AAC7C;;AAEA;EACE,mCAAQ,aAAa,EAAE;EACvB,0CAAe,0BAA0B,EAAE;EAC3C,oCAAS,iBAAiB,EAAE;EAC5B,2CAAgB,iBAAiB,EAAE;AACrC","sourcesContent":[".page { max-width: 1600px; display: flex; flex-direction: column; gap: 1.5rem; padding: 0; }\n.loading { padding: 2rem; color: var(--gray-500); font-size: 0.85rem; }\n.noResult { padding: 2rem; color: var(--gray-500); display: flex; flex-direction: column; gap: 1rem; }\n\n.topBar { display: flex; align-items: center; justify-content: flex-start; margin-bottom: 1rem; }\n.backBtn { background: none; border: none; color: var(--green); font-size: 0.82rem; font-weight: 500; padding: 0; cursor: pointer; }\n.backBtn:hover { text-decoration: underline; }\n\n.header { margin-bottom: 1.5rem; }\n.title { font-size: 1.8rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }\n.subtitle { font-size: 0.9rem; color: var(--gray-600); }\n\n.section { margin-bottom: 2rem; }\n.sectionTitle { font-size: 1.2rem; font-weight: 700; color: var(--black); margin-bottom: 1.2rem; border-bottom: 2px solid var(--green); padding-bottom: 0.5rem; }\n\n.insightGrid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; }\n\n.insightCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1.2rem;\n  display: flex;\n  gap: 1rem;\n  transition: all 0.3s;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.insightCard:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.insightIcon {\n  width: 50px;\n  height: 50px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  flex-shrink: 0;\n}\n\n.insightContent { flex: 1; }\n.insightTitle { font-size: 0.8rem; color: var(--gray-600); font-weight: 600; margin-bottom: 0.3rem; text-transform: uppercase; letter-spacing: 0.03em; }\n.insightValue { font-size: 1.4rem; font-weight: 700; margin-bottom: 0.4rem; }\n.insightDesc { font-size: 0.78rem; color: var(--gray-600); line-height: 1.4; }\n\n.subsectionTitle { font-size: 0.95rem; font-weight: 700; color: var(--gray-900); margin-bottom: 0.8rem; }\n\n.strengthsList { display: flex; flex-direction: column; gap: 0.6rem; }\n.strengthItem {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 0.9rem;\n  background: rgba(26, 92, 56, 0.04);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n}\n\n.strengthRank {\n  font-weight: 700;\n  color: var(--green);\n  width: 28px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.strengthLabel { color: var(--gray-900); flex: 1; font-weight: 500; }\n.strengthValue { font-weight: 700; }\n\n.analysisCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1.2rem;\n}\n\n.analysisTitle { font-size: 0.95rem; font-weight: 700; color: var(--gray-900); margin-bottom: 0.6rem; }\n.analysisDesc { font-size: 0.85rem; color: var(--gray-700); line-height: 1.6; }\n\n.levelBarItem { margin-bottom: 1rem; }\n.levelLabel { font-size: 0.8rem; font-weight: 600; color: var(--gray-900); margin-bottom: 0.4rem; }\n\n.levelBarContainer {\n  display: flex;\n  gap: 0.8rem;\n  align-items: center;\n}\n\n.levelBarTrack {\n  flex: 1;\n  display: flex;\n  gap: 2px;\n}\n\n.levelSegment {\n  height: 12px;\n  border-radius: 6px;\n  transition: background 0.3s;\n}\n\n.levelText { font-size: 0.78rem; font-weight: 600; color: var(--gray-700); min-width: 70px; text-align: right; }\n\n.roadmapList { display: flex; flex-direction: column; gap: 0.8rem; }\n.roadmapItem {\n  padding: 1rem;\n  background: linear-gradient(135deg, var(--green-light) 0%, rgba(26, 92, 56, 0.03) 100%);\n  border: 1px solid rgba(26, 92, 56, 0.15);\n  border-radius: var(--radius);\n  border-left: 4px solid var(--green);\n}\n\n.roadmapPhase {\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--green);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  margin-bottom: 0.4rem;\n}\n\n.roadmapItem p {\n  font-size: 0.85rem;\n  color: var(--gray-700);\n  line-height: 1.5;\n  margin: 0;\n}\n\n@media (max-width: 1024px) {\n  .insightGrid { grid-template-columns: repeat(2, 1fr); }\n  \n  .roadmapList { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 768px) {\n  .page { padding: 1rem; }\n  .insightGrid { grid-template-columns: 1fr; }\n  .title { font-size: 1.5rem; }\n  .sectionTitle { font-size: 1.1rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminResultInsights_page__8PFSf`,
	"loading": `AdminResultInsights_loading__MHZg-`,
	"noResult": `AdminResultInsights_noResult__QjSON`,
	"topBar": `AdminResultInsights_topBar__+IGx5`,
	"backBtn": `AdminResultInsights_backBtn__PQ9ne`,
	"header": `AdminResultInsights_header__PJF8p`,
	"title": `AdminResultInsights_title__WmBNL`,
	"subtitle": `AdminResultInsights_subtitle__p4nmf`,
	"section": `AdminResultInsights_section__IgwIq`,
	"sectionTitle": `AdminResultInsights_sectionTitle__N1ZBY`,
	"insightGrid": `AdminResultInsights_insightGrid__nmY5M`,
	"insightCard": `AdminResultInsights_insightCard__amULn`,
	"insightIcon": `AdminResultInsights_insightIcon__NENxY`,
	"insightContent": `AdminResultInsights_insightContent__Wl-bG`,
	"insightTitle": `AdminResultInsights_insightTitle__A48Ya`,
	"insightValue": `AdminResultInsights_insightValue__ebybJ`,
	"insightDesc": `AdminResultInsights_insightDesc__6pyNo`,
	"subsectionTitle": `AdminResultInsights_subsectionTitle__tolo3`,
	"strengthsList": `AdminResultInsights_strengthsList__VlG9m`,
	"strengthItem": `AdminResultInsights_strengthItem__9zr+H`,
	"strengthRank": `AdminResultInsights_strengthRank__t70Se`,
	"strengthLabel": `AdminResultInsights_strengthLabel__rIt8x`,
	"strengthValue": `AdminResultInsights_strengthValue__RfY94`,
	"analysisCard": `AdminResultInsights_analysisCard__vchb2`,
	"analysisTitle": `AdminResultInsights_analysisTitle__LEuqV`,
	"analysisDesc": `AdminResultInsights_analysisDesc__qN3Yg`,
	"levelBarItem": `AdminResultInsights_levelBarItem__+sDmx`,
	"levelLabel": `AdminResultInsights_levelLabel__HFZs3`,
	"levelBarContainer": `AdminResultInsights_levelBarContainer__Wujy8`,
	"levelBarTrack": `AdminResultInsights_levelBarTrack__wfGWY`,
	"levelSegment": `AdminResultInsights_levelSegment__EVCos`,
	"levelText": `AdminResultInsights_levelText__pxNHh`,
	"roadmapList": `AdminResultInsights_roadmapList__3B-Xd`,
	"roadmapItem": `AdminResultInsights_roadmapItem__xPho+`,
	"roadmapPhase": `AdminResultInsights_roadmapPhase__OxwQR`
};
export default ___CSS_LOADER_EXPORT___;
